/**
 * The non-operational status banner.
 *
 * FE-1 Stage Work Item §4.1 B requires a "non-operational status banner" in the App
 * Shell. This is a governance-facing element, not decoration: the foundation is
 * synthetic engineering, and the banner is what keeps that visible in the product
 * surface rather than only in a document.
 *
 * It asserts nothing operational. It claims no readiness, no availability, no
 * deployment and no authority — because FE1-W0 has none of those.
 */
export function NonOperationalBanner() {
  return (
    <section className="fe1w0-banner" aria-labelledby="fe1w0-banner-heading">
      <h2 className="fe1w0-banner__heading" id="fe1w0-banner-heading">
        Non-operational foundation
      </h2>
      <p className="fe1w0-banner__body">
        This is a synthetic engineering foundation. It displays no operational data, contacts no
        backend, controls no device, and authorizes no action.
      </p>
      <p className="fe1w0-banner__body">
        Anything it can display is a read model, and a read model is never permission to act.
      </p>
    </section>
  );
}
